import React, { useState } from "react";
import { LucideLogOut, CircleUser, KeyRound } from "lucide-react";
import { ModelCustom } from "components/shared";
import ResetPasswordForm from "templates/Reset-Password/ResetPasswordForm";
import { useResetPassword } from "hooks";
import { useNavigate } from "react-router-dom";

interface IProfileMenu {
  auth?: any;
}

const ProfileMenu: React.FC<IProfileMenu> = ({ auth }: any) => {
  const [open, setOpen] = useState(false);
  const { onResetPassword } = useResetPassword();
  const navigate = useNavigate();
  
  const onLogout = () => {
    window.localStorage.clear();
    navigate("/login");
  };
  const userName = `${auth.user.firstname} ${auth.user.lastname}`;
  return (
    <div>
      <div className="flex flex-col border border-theme700 backdrop-blur-xl text-textGray rounded-md bg-theme50 min-w-[14rem]">
        <div className="flex items-center gap-3 rounded-t-md bg-theme50 py-2 px-4 border-b-2 border-b-theme700">
          <CircleUser className="h-6 w-6 cursor-pointer" />

          <div className="pr-2">
            <div className="text-p2">{userName}</div>
            <div className="text-p3"> {auth?.user?.email || " "} </div>
          </div>
        </div>

        <div className="text-p2">
          <div
            className="px-4 py-2 hover:bg-pureWhite/20 cursor-pointer"
            onClick={onLogout}
          >
            <div className="flex gap-2 items-center ">
              <div>
                <LucideLogOut className="size-4" />
              </div>
              <div>Sign Out</div>
            </div>
          </div>
          <div
            className="px-4 py-2 hover:bg-pureWhite/20 cursor-pointer"
            onClick={() => setOpen(true)}
          >
            <div className="flex gap-2 items-center">
              <div>
                <KeyRound className="size-4" />
              </div>
              <div>Change Password</div>
            </div>
          </div>
        </div>
      </div>
      <ModelCustom
        isOpen={open}
        setIsOpen={setOpen}
        title="Reset Password"
        children={<ResetPasswordForm onSubmit={onResetPassword} />}
      />
    </div>
  );
};

export default ProfileMenu;
